var Price = /** @class */ (function () {
    function Price(price) {
        this.value = price;
    }
    Price.prototype.decimalPart = function () {
        if (this.value < 0) {
            return undefined;
        }
        var splitPrice = (this.value + '').split('.');
        if (!splitPrice[1]) {
            return '00';
        }
        return splitPrice[1].length > 1 ? splitPrice[1] : splitPrice[1] + '0';
    };
    Price.prototype.integerPart = function () {
        if (this.value < 0) {
            return undefined;
        }
        var splitPrice = (this.value + '').split('.');
        return splitPrice[0];
    };
    Price.prototype.integerPartNumber = function () {
        if (this.value < 0) {
            return undefined;
        }
        return Math.trunc(this.value);
    };
    return Price;
}());
export { Price };
